import script from "./AlphaPostInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AlphaPostInfo.vue?vue&type=script&setup=true&lang=js"

import "./AlphaPostInfo.vue?vue&type=style&index=0&id=07a6dd58&lang=scss"

const __exports__ = script;

export default __exports__